﻿/* istanbul ignore file */
import { TranslationsNamespaceProvider } from '@ori/i18n';
import { ErrorBoundary } from '@ori/logger';
import { TestIdProvider } from '@ori/testid-generator';
import type { FC, PropsWithChildren } from 'react';

import { APP_TEAM_NAME, translationsNamespace } from '../constants';
import { APP_NAME } from '../constants-generated';

export const ComponentWrapper: FC<PropsWithChildren> = ({ children }) => (
  <ErrorBoundary areaName="ComponentWrapper">
    <TestIdProvider
      team={APP_TEAM_NAME}
      project={APP_NAME}
    >
      <TranslationsNamespaceProvider namespace={translationsNamespace}>{children}</TranslationsNamespaceProvider>
    </TestIdProvider>
  </ErrorBoundary>
);
